var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatBubblePointer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M1.698.143a28.5 28.5 0 0 0 5.37 2.404c1.689.563 3.366-.758 3.366-2.537v21.81a17 17 0 0 0-3.023-9.676L.18 1.7C-.458.779.726-.415 1.697.143"
})));
export default SvgChatBubblePointer;